import { type Color } from '@mui/material'

export const blue = {
  100: '#E5F2FC',
  200: '#CCE4F9',
  300: '#99C9F2',
  400: '#66AFEC',
  500: '#3394E5',
  600: '#0076D6',
  700: '#0061B2',
  800: '#004986',
  900: '#003059',
} satisfies Partial<Color>
